<template>
  <FlashSalesModal
    v-if="productResponse && flashSalesDiscount && shouldDisplayFlashSales"
    :category-id="productResponse.tracking.categoryId"
    :discount="flashSalesDiscount"
  />
  <SellerFlashSalesModal
    v-else-if="productResponse && productResponse.hasDeals"
    :product-id="productResponse.productId"
    :product-name="productResponse.titles.raw"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import FlashSalesModal from '@backmarket/nuxt-layer-recommendation/FlashSalesModal.vue'
import SellerFlashSalesModal from '@backmarket/nuxt-layer-recommendation/SellerFlashSalesModal.vue'
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'

import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'

const { data: productResponse } = useFetchProduct()
const experiments = useExperiments()

const shouldDisplayFlashSales =
  experiments['experiment.flashSales'] === 'enabled'

const flashSalesDiscount = computed(
  () =>
    productResponse.value?.promoCodes.find((promoCode) => promoCode.isFlashSale)
      ?.discountValue,
)
</script>
